const navigation = [
  {
    _tag: "CSidebarNavItem",
    name: "相談者一覧",
    to: "/user",
    icon: "cilChartPie",
  },
];
export default navigation;
